import React from 'react'
import ApplicationSetupModal from 'components/ApplicationSetupModal'
import injectSheet from 'react-jss'
import style from './style'
import logo from 'images/logo'

const Loading = ({ classes }) => {
  return (
    <div className={EXPORT ? 'EXPORT' : ''}>
      <ApplicationSetupModal />
      <div style={{
        flex: '1 1 auto',
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
      }}>
        <div className={classes.topBar}>
          <div className={classes.wrapper}>
            <div className={classes.logoWrapper}>
              <a href={IPVM_URL}>
                <img src={logo} alt='IPVM Logo' />
              </a>
            </div>
            <div className={classes.inputWrapper}>
              <div className={classes.projectTitle}>
                <div className={classes.projectInput} />
              </div>
              <div>
                <div className={classes.dropdown} />
                <div className={classes.dropdown} />
                <div className={classes.dropdown} />
              </div>
            </div>
          </div>
          <div className={classes.rightSideThings}>
            <div className={classes.rightSideButton} style={{ marginRight: '5px' }}>
              <div className={classes.rightSideInnerButton} />
            </div>
            <div className={classes.rightSideButton}>
              <div className={classes.rightSideInnerButton} />
            </div>
          </div>
        </div>
        <div className={classes.map} />
      </div>
      <div className={classes.sideBar}>
        <div className={classes.sidebarTitle}>
          <div className={classes.sidebarTitleInner}>
            <div className={classes.sideBarTitleText} />
          </div>
        </div>
        <div className={classes.generalPane}>
          <div className={classes.loading} style={{ height: '27px', width: '100%', marginBottom: '5px' }} />
          <div className={classes.loading} style={{ height: '27px', width: '100%', marginBottom: '5px' }} />

          <div>
            <div className={classes.loading} style={{ height: '27px', width: '40%', marginRight: '5px', display: 'inline-block' }} />
            <div className={classes.loading} style={{ height: '27px', width: '58%', display: 'inline-block' }} />
          </div>

          <div>
            <div className={classes.loading} style={{ height: '27px', width: '40%', marginRight: '5px', display: 'inline-block' }} />
            <div className={classes.loading} style={{ height: '27px', width: '58%', display: 'inline-block' }} />
          </div>

          <div>
            <div className={classes.loading} style={{ height: '27px', width: '40%', marginRight: '5px', display: 'inline-block' }} />
            <div className={classes.loading} style={{ height: '27px', width: '58%', display: 'inline-block' }} />
          </div>

          <div>
            <div className={classes.loading} style={{ height: '27px', width: '40%', marginRight: '5px', display: 'inline-block' }} />
            <div className={classes.loading} style={{ height: '27px', width: '58%', display: 'inline-block' }} />
          </div>
        </div>
        <div className={classes.sidebarTitle}>
          <div className={classes.sidebarTitleInner}>
            <div className={classes.sideBarTitleText} />
          </div>
        </div>
        <div className={classes.sidebarTitle}>
          <div className={classes.sidebarTitleInner}>
            <div className={classes.sideBarTitleText} />
          </div>
        </div>
        <div className={classes.sidebarTitle}>
          <div className={classes.sidebarTitleInner}>
            <div className={classes.sideBarTitleText} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default injectSheet(style)(Loading)



// WEBPACK FOOTER //
// ./src/components/Loading/index.js